export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px 0',
};
